// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"e7fb6873","948":"4317da75","984":"1dc371a7"}[chunkId] + ".chunk.js";
};